import { atom } from 'recoil';
import { categories, products } from '../utils/db';

export const productsState = atom({
    key: `productsState`,
    default: products,
})

export const categoriesState = atom({
    key: `categoriesState`,
    default: categories,
})

export const scrollMenu = atom({
    key: 'scrollMenu',
    default: 0,
})

export const openCategories = atom({
    key: 'openCategories',
    default: [""],
})

export const cartState = atom({
    key: 'cartState',
    default: localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")!) : [],
})

export const orderState = atom({
    key: 'orderState',
    default: localStorage.getItem("order") ? JSON.parse(localStorage.getItem("order")!) : [],
})